import { User } from '@qality/common-model';
import { AvatarUrls } from '@qality/common-model/src/Issue';

const IDENTIFIER = 'key';
class UserImpl implements User {
  key: string;
  displayName: string;
  avatarUrls: AvatarUrls;

  constructor(user: User) {
    Object.assign(this, user);
  }

  getIdentifier(): string {
    return this.key;
  }

  getAvatar(): any {
    return this.avatarUrls?.['24x24'];
  }

  getDisplayName(): string {
    return this.displayName;
  }

  static getIdentifierName(): string {
    return IDENTIFIER;
  }
}

export default UserImpl;
export { IDENTIFIER };
